module.exports = __webpack_public_path__ + "img/b6-4.fd3e7fd.png";